import { Col, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { CampaignResponseForm } from "./campaign-response-form";
import type { MyStatus } from "@/services/hardware-self-service/hardware-self-service.types";

interface MyBaseliningPanelProps {
  status?: MyStatus;
  currentUsername: string;
}

export const MyBaseliningPanel: FC<MyBaseliningPanelProps> = ({ status, currentUsername }) => (
  <View padding="S300" border="1px solid neutral20" borderRadius="R400">
    <Col gridGap="S300">
      {status?.campaign && (
        <Text fontSize="20px" fontWeight="bold">
          {status.campaign.name}
        </Text>
      )}
      <CampaignResponseForm
        campaign={status?.campaign}
        assets={status?.assets ?? []}
        existingResponses={status?.responses ?? {}}
        existingPickupAddress={status?.pickupAddress}
        login={currentUsername}
        currentUsername={currentUsername}
        scope={status?.scope}
      />
    </Col>
  </View>
);
